<style lang="scss" scoped>
.subscription {
  color: #606266;
}
.date:not(:last-child):after {
  content: '、';
}
.product {
  margin: 5px 0;
}
</style>

<template>
  <div class="subscription">
    <div class="container">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item>
          <el-input placeholder="请输入周期购名称" v-model="params.name"></el-input>
        </el-form-item>
        <el-button @click="onSearch" size="small">搜索</el-button>
        <el-button type="primary" size="small" @click="$router.push({ name: 'subscription-edit' })">新增周期购</el-button>
      </el-form>
    </div>
    <div class="container fr-aic fr-jcsb">
      <comp-tab :data="[{ label: '全部周期购', value: null }, { label: '生效中', value: 2 }, { label: '已结束', value: 1 }]" v-model="params.enabled" />
    </div>
    <div class="container">
      <el-table :data="list">
        <el-table-column prop="name" label="周期购名称"></el-table-column>
        <!-- <el-table-column prop="minissuecount" label="起送"></el-table-column> -->
        <!-- <el-table-column prop="beforedaycount" label="提前天数"></el-table-column>
        <el-table-column prop="beforeoftheclock" label="提前小时"></el-table-column> -->
        <el-table-column prop="productidlistList" label="适用商品">
          <template slot-scope="scope">
            <el-tag size="small" class="product" v-for="p of scope.row.productlist" :key="p.id">{{ p.name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="kind" label="配送周期">
          <template slot-scope="scope">
            <span>
              {{ getTypeText(scope.row.kind) }}
              <span v-show="scope.row.kind !== 1">|</span>
              <template v-if="scope.row.kind === 2">
                每周<span class="date" v-for="date of scope.row.weeklistList" :key="date">周{{ getWeekday(date) }}</span
                >配送
              </template>
              <template v-if="scope.row.kind === 3">
                每月<span class="date" v-for="date of scope.row.datelistList" :key="date">{{ date }}日</span>配送
              </template>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="
                () => {
                  $router.push({
                    name: 'subscription-edit',
                    query: { id: scope.row.id }
                  });
                }
              "
              size="small"
              type="text"
              >编辑</el-button
            >
            <el-button v-show="scope.row.enabled === 2" @click="disable(scope.row)" size="small" type="text">停用</el-button>
            <el-button v-show="scope.row.enabled === 1" @click="enable(scope.row)" size="small" type="text">启用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="container" style="text-align: center;">
      <el-button v-show="!noMore" @click="() => getList(true)" size="small" type="primary">加载更多</el-button>
      <span v-show="noMore" style="color: #ccc; font-size: 12px;">已加载全部，没有更多了</span>
    </div>
  </div>
</template>

<script>
import { M } from '../../../service/grpc';
import { rpc } from '../../../service/index';
import { getToken } from '../../../service/helper';
import Tab from '../../../components/tab/index.vue';

export default {
  components: {
    'comp-tab': Tab
  },
  data() {
    return {
      list: [],
      params: {
        name: '',
        enabled: null
      },
      noMore: false
    };
  },
  watch: {
    'params.enabled': function() {
      this.getList();
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getTypeText(t) {
      switch (t) {
        case 1:
          return '每日一期';
        case 2:
          return '每周一期';
        case 3:
          return '每月一期';
        default:
          return '';
      }
    },
    getWeekday(d) {
      switch (d) {
        case 1:
          return '一';
        case 2:
          return '二';
        case 3:
          return '三';
        case 4:
          return '四';
        case 5:
          return '五';
        case 6:
          return '六';
        case 7:
          return '日';
        default:
          return '';
      }
    },
    getList(more) {
      rpc(
        'StoreSubscriptionService.GetSubscriptionList',
        M('SubscriptionListQueryRequest', {
          token: M('Token', { token: getToken() }),
          ...this.params,
          count: 20,
          idlessthan: more && this.list.length ? this.list[this.list.length - 1].id : null
        })
      ).then(async res => {
        const list = res.subscriptionlistList;
        if (list) {
          this.list = more ? this.list.concat(list) : list;
          this.list.forEach(it => {
            if (it.datelistList && it.datelistList.length) {
              it.datelistList.sort((a, b) => a - b);
            }
            if (it.weeklistList && it.weeklistList.length) {
              it.weeklistList.sort((a, b) => a - b);
            }
          });
          if (list.length) {
            this.noMore = false;
          } else if (more) {
            this.noMore = true;
            this.$message({
              type: 'info',
              message: '没有更多了'
            });
          }
          this.resolveProducts();
        }
      });
    },
    async resolveProducts() {
      const productidlist = this.list.reduce((l, c) => l.concat(c.productidlistList), []);
      const res = await rpc(
        'StoreProductService.GetProductList',
        M('ProductListQueryRequest', {
          token: M('Token', { token: getToken() }),
          idlistList: productidlist,
          count: productidlist.length
        })
      );
      this.list.forEach(item => {
        this.$set(item, 'productlist', item.productidlistList.map(v => res.productlistList.find(vv => vv.id === v)));
      });
    },
    disable(item) {
      this.$confirm(`确定要停用周期购“${item.name}”吗？`, '停用周期购', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          rpc(
            'StoreSubscriptionService.UpdateSubscription',
            M('SubscriptionWithTokenRequest', {
              token: M('Token', { token: getToken() }),
              subscription: M('Subscription', {
                ...item,
                enabled: 1
              })
            })
          ).then(res => {
            if (res) {
              // this.$set(item, 'enabled', 1)
              this.getList();
              this.$message({
                type: 'success',
                message: '停用成功!'
              });
            }
          });
        })
        .catch(() => {});
    },
    enable(item) {
      rpc(
        'StoreSubscriptionService.UpdateSubscription',
        M('SubscriptionWithTokenRequest', {
          token: M('Token', { token: getToken() }),
          subscription: M('Subscription', {
            ...item,
            enabled: 2
          })
        })
      ).then(res => {
        if (res) {
          // this.$set(item, 'enabled', 2)
          this.getList();
          this.$message({
            type: 'success',
            message: '启用成功!'
          });
        }
      });
    }
  }
};
</script>
